import { dataCoinDiamond } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCoinDiamond = /*#__PURE__*/createIcon(dataCoinDiamond)
export default IconCoinDiamond
